import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { extendedTestimonials, testimonials } from '../data/content';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="3gqq7tayrgake">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-170" data-mp="3brwsre3tsbi4" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+180', 'mujeres aplicando el protocolo'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-171" data-mp="3btx66pzmda5">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-172" data-mp="3do5mlk2ocxc">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-173" data-mp="da10hmrcswto">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-174" data-mp="daj454gcidbm">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-175" data-mp="8bzg8yi6yrgm">{label}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-176" data-mp="1lby03x24ii0h">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-177" data-mp="1lchg3887qwbv">
          {testimonials.map(([initials, name, place, quote], index) => <Reveal as="article" key={name} delay={index * 60} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-178" data-mp="1qdevjd1u9c9o" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-179" data-mp="1zapbhbplppkx">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-180" data-mp="24atsd2uf8mbo">{initials}</div>
                <div data-id="element-181" data-mp="292uz698tlkub">
                  <h3 className="font-bold" data-id="element-182" data-mp="292bqzk8z2ath">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-183" data-mp="2e0wkl0tpxw8y">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-184" data-mp="2i39orksthm3m"><Stars data-id="element-185" data-mp="2i3t8n7212kka" /></div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-186" data-mp="2i0dr7xkvszfp">“{quote}”</p>
            </Reveal>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-187" data-mp="mwz87z62hrry">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="izb9sm561gvb">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-189" data-mp="wolgpnr0tcr0">
          LO QUE DICEN LAS MUJERES QUE YA LO APLICARON
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-190" data-mp="rw234qsc2hm7">
          {extendedTestimonials.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-191" data-mp="16ovtj7958i5n">
              <Stars data-id="element-192" data-mp="11nomxbiqlp0k" />
              <p className="mt-2 font-bold" data-id="element-193" data-mp="11qav9ddgc8ju">{name} <span className="font-normal text-slate-400" data-id="element-194" data-mp="1fnzekgrvf7ms">· {place}</span></p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-195" data-mp="1aow9iwbw51et">{quote}</p>
            </article>)}
        </div>
        <p className="mt-10 text-center text-xs text-slate-500" data-id="element-196" data-mp="3hg5g3dz32on9">
          Experiencias personales. Los resultados pueden variar según cada persona.
        </p>
      </div>
    </section>;
}